exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-buttons .btn {\n  margin-right: 20px; }\n\nform {\n  display: table;\n  width: 100%; }\n  form > div {\n    display: table-row; }\n    form > div > label {\n      display: table-cell;\n      width: 100px;\n      margin-top: 5px;\n      margin-bottom: 5px; }\n    form > div > input {\n      display: table-cell;\n      margin-top: 5px;\n      margin-bottom: 5px; }\n    form > div > div {\n      display: table-cell;\n      margin-top: 5px;\n      margin-bottom: 5px; }\n\n.required-text {\n  width: 100%;\n  font-size: 14px;\n  margin-top: 12px;\n  font-style: italic; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/modals/components/modalSurvey/modalSurvey.scss
// module id = ../../../../../src/app/theme/components/modals/components/modalSurvey/modalSurvey.scss
// module chunks = 14